import React from "react";
import PropTypes from "prop-types";
import HorizontalStackBar from "../../HorizontalStackBar/HorizontalStackBar";

function SinglePointStatsBar({ data, type = "forehand", title = "Dritto" }) {
  let vincenti = data.winner[type];
  let forzati = data.forced[type];
  let gratuiti = data.error[type];

  const chartData = [
    {
      label: "Vincenti",
      value: vincenti,
      backgroundColor: "#5cb85c",
    },
    {
      label: "Forzati",
      value: forzati,
      backgroundColor: "#f0ad4e",
    },
    {
      label: "Gratuiti",
      value: gratuiti,
      backgroundColor: "#d9534f",
    },
  ];
  return (
    <HorizontalStackBar labels={["Colpi"]} data={chartData} title={title} />
  );
}

SinglePointStatsBar.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.oneOf(["forehand", "backhand", "volley", "smash"]),
  title: PropTypes.string,
};

export default SinglePointStatsBar;
